export default __webpack_public_path__ + "static/media/app-bar-logo.b75b8ed6.svg";